// extracted by mini-css-extract-plugin
export default {"subqueryRow":"SubQuery_subqueryRow__p64V6","card":"SubQuery_card__26eOr"};